export const defaultFilterMarkerOrder = [
  'temperature',
  'rainfall',
  'wind',
  'humidity',
  'pressure',
  'soil-moisture',
  'soil-temperature',
];
